import React, {Fragment, useEffect, useState} from 'react'
import {Button,Col,Container, Form, Row} from 'react-bootstrap'
import {FaCheck} from 'react-icons/fa'
import {GoDash} from 'react-icons/go'
import { useDispatch, useSelector } from 'react-redux'
import { configuracionFormAction, configuracionFormAction33, obtenerAntecedentesCaso, ObtenerHitosCaso, obtenerIdSeguro } from '../../store/actions/caso-general-action'
import { obtenerGrillaImplicado } from '../../store/actions/implicado-action'
import DetallesCabecera from './detallesCabecera'
import { LoadingComponent } from 'recupero-comunes'

const CompleteOld=()=>{  
    return (

    <Button key='complete' style={{borderRadius:'360px', width:'80px', height:'80px', backgroundColor:'#8ac37f', border:'none', marginLeft:'5px'}}>
        <FaCheck size={30} style={{color:'white'}}/>
        </Button>
    )
}

const IncompleteOld=()=>(
    <Button  key='incomplete'  style={{borderRadius:'360px', width:'80px', height:'80px', backgroundColor:'white', border:'3px solid #C4C5C2', marginLeft:'5px'}}>
    <GoDash size={50} style={{color:'black'}}/>
    </Button>
)
const Complete=()=>{  
  return (
    <>
    <style type='text/css'>
      {`
      .btn-complete {
        border-radius:360px;
        width:80px;
        height:80px;
        background-color:#8AC34A; 
        border:none;
        margin-left:5px;
      }
      .btn-subir:hover{
        background-color:#01cec8;
        color: #FFFFFF;
        
      } 
    `} </style>
      <Button key='complete' variant='complete'>
        <FaCheck size={30} style={{color:'white'}}/>
      </Button>
    </>
  )
}
const Incomplete=()=>{  
  return (
    <>
    <style type='text/css'>
      {`
      .btn-incomplete {
        border-radius:360px;
        width:80px;
        height:80px;
        background-color:white; 
        border:3px solid #C4C5C2;
        margin-left:5px;
      }
      .btn-incomplete:hover{
        background-color:#01cec8;
        color: #FFFFFF;
        
      } 
    `} </style>
      <Button key='incomplete' variant='incomplete'>
        <GoDash size={50} style={{color:'black'}}/>
      </Button>
    </>
  )
}

const HitosCaso = () => {
 
  const [loading, setLoading]=useState(false)
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const { hitosCasoR, llaves, antecedentesCasos } = data_datos_generales

  const dispatch=useDispatch()
  useEffect(() => {
    if (llaves) {
      setLoading(true)
      let query = Buffer.from(
        JSON.stringify({
          idOrgCaso: llaves['idOrgCaso'],
          idCaso: llaves['idCaso']
        })
      ).toString('base64')
      dispatch(obtenerAntecedentesCaso(query))
      
      .then(()=>{
        if (llaves) {
          let query = Buffer.from(
            JSON.stringify({ idform: 7, rutcia:llaves['idOrgCaso']})
          ).toString('base64')
          dispatch(configuracionFormAction(query))
        }
      }).then(()=>{
        if (llaves) {
          let query = Buffer.from(
            JSON.stringify({ idform: 33, rutcia:llaves['idOrgCaso']})
          ).toString('base64')
          dispatch(configuracionFormAction33(query))
        }
      })
      .then(()=>{
        let query = Buffer.from(
          JSON.stringify({
            idOrgCaso: llaves['idOrgCaso'],
            idCaso: llaves['idCaso']
          })
        ).toString('base64')
        dispatch(obtenerGrillaImplicado(query))
      })
      .then(()=>{
       
      })
      .then(()=>setLoading(false))
    }
  }, [dispatch, llaves])
  useEffect(()=>{
    
    if (llaves && antecedentesCasos) {
      
      let idSeguroTercero = (antecedentesCasos && antecedentesCasos.antecedentesCasos[0]) ? antecedentesCasos.antecedentesCasos[0]['IdSeguroTercero'] : 0;
      let idTipoGestion = (antecedentesCasos && antecedentesCasos.antecedentesCasos[0]) ? antecedentesCasos.antecedentesCasos[0]['IdTipoGestion'] : 0;
      let idTipoGestionWFL = (antecedentesCasos && antecedentesCasos.antecedentesCasos[0]) ? antecedentesCasos.antecedentesCasos[0]['TipoGestionWFL'] : 0;

      let flujoGestion = 235002; //Recupero Directo
      if (idTipoGestionWFL && idTipoGestionWFL > 0) {
      
        flujoGestion = idTipoGestionWFL;
      
      } else {

        if (idTipoGestion == 207001 && (idSeguroTercero == 212002 || idSeguroTercero == 212003)) {
          flujoGestion = 235001;//Recupero entre CIAs
        } else {
          if (idTipoGestion == 207002 && (idSeguroTercero == 212002 || idSeguroTercero == 212003)) {
            flujoGestion = 235005;//Defensa entre CIAs
          } else {
            if (idTipoGestion == 207002) {
              flujoGestion = 235003;//Defensa directa
            }
          }
        }
      }

      let query = Buffer.from(
        JSON.stringify({
          "tipoGestion":flujoGestion,
          "idOrganizacion":llaves['idOrgCaso'],
          "idCaso":llaves['idCaso'] 
        })
      ).toString('base64')
      dispatch(ObtenerHitosCaso(query))
    }
  },[antecedentesCasos,llaves])

  return (
   <>
   <LoadingComponent show={loading}/>
   <DetallesCabecera/>
    <div className='mb-3 mt-3 p-4' style={{border:'2px solid #01CECA', borderRadius:'5px'}}> 
    <Row>
      {hitosCasoR && hitosCasoR.hitosCasoR.map(h=>(
        <Col key={h.Orden}>
          <Form.Label
                className='mb-1'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
               {h.Etapa}
              </Form.Label>
              <br/>
              {h.IndEtapaRealizada >0 ? <Complete/>:<Incomplete/>}
              <br/>
              <Form.Label
                className='mb-1 mt-3 mx-2'
                style={{ fontWeight: 'bold', fontSize: '14px', marginLeft:'5px' }}
              >
               {h.MaxFechaIngreso }
              </Form.Label> 
        </Col>

      ))}
     </Row> 
   
        
       
    </div>
   </>
   
    
  )
}

export default HitosCaso